function syncMeta(el, binding, meta) {
  const fieldName = el.name || el.id
  const instance = binding.instance

  if (!fieldName || !meta || !instance || typeof instance.syncVeeFieldMeta !== 'function') {
    return
  }

  instance.syncVeeFieldMeta(fieldName, meta)
}

function applyClasses(el, meta) {
  if (!meta) return

  const isCheckbox = el.type === 'checkbox'
  const isFilled = isCheckbox ? !!el.checked : !!el.value

  const showValidationState = !!meta.validated || !!meta.touched || !!meta.dirty || isFilled

  el.classList.toggle('valid', showValidationState && !!meta.valid)
  el.classList.toggle('invalid', showValidationState && !meta.valid)
  toggleClass(el, 'touched', 'untouched', meta.touched)
  toggleClass(el, 'dirty', 'pristine', meta.dirty)
  toggleClass(el, 'filled', 'empty', isFilled)
}

function toggleClass(el, trueClass, falseClass, condition) {
  if (condition) {
    el.classList.add(trueClass)
    el.classList.remove(falseClass)
  } else {
    el.classList.add(falseClass)
    el.classList.remove(trueClass)
  }
}

export default {
  mounted(el, binding) {
    const { meta } = binding.value || {}
    syncMeta(el, binding, meta)
    applyClasses(el, meta)
  },
  updated(el, binding) {
    const { meta } = binding.value || {}
    syncMeta(el, binding, meta)
    applyClasses(el, meta)
  },
}
